<template>
    <div
        :class="[
            'back-button',
            {
                'back-button--black': isBlack,
                'back-button--no-absolute': !isAbsolute,
                'back-button--hidden-on-desktop': isHiddenOnDesktop,
                'back-button--partner-custom-embed': partnerAppEmbedCustomization,
                'back-button--arabic': isArabic
            }
        ]"
        @click="goBack()"
    />
</template>

<script>
import {
    mapGetters,
} from 'vuex';

export default {
    name: 'back-button',
    props: {
        isBlack: {
            type: Boolean,
            default: false,
        },
        isAbsolute: {
            type: Boolean,
            default: true,
        },
        isHiddenOnDesktop: {
            type: Boolean,
            default: false,
        },
        isArabic: {
            type: Boolean,
            default: false,
        },
        customCallback: {
            type: Object,
            default: () => ({}),
        },
        routeToHome: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters(['partnerAppEmbedCustomization']),
    },
    methods: {
        goBack() {
            if (this.customCallback && Object.keys(this.customCallback).length > 0) {
                this.$router.replace(this.customCallback);
            } else if (this.routeToHome) {
                this.$router.replace('/home/overview');
            } else {
                this.$router.go(-1);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.back-button {
    display: flex;
    position: absolute;
    z-index: 2;
    left: 5%;
    top: 2rem;
    background: rgba(255, 255, 255, 0.2);
    @include chevron($white-color, 3.25rem);
    @include chevron-back();

    &--black {
        @include chevron($cyprus-color, 3.25rem);
        @include chevron-back();
    }

    &--no-absolute {
        position: inherit;
        left: 0.5rem;
        top: 0;
        margin-left: auto;
    }

    &--hidden-on-desktop {
        @include min-width(md) {
            display: none;
        }
    }

    &--partner-custom-embed {
        display: flex;
    }

    &--arabic {
        @include chevron-forward();
    }
}
</style>